export default class StyledCheckboxDefault {
    constructor(element = 'js-styled-checkbox') {
        this.element = element;
        this.input = null;
        this.childInputs = [];
        this.outsideParentItem = null;
        this.outsideParentInput = null;
        this.subtopicItems = [];
        this.classList = {
            inputClass: 'js-styled-checkbox-input',
            outsideParentItemClass: 'js-parent-checkbox',
            outsideParentInputClass: 'js-parent-checkbox-input',
            subtopicItemClass: 'js-subtopic-checkbox',
            subtopicInputClass: 'js-subtopic-checkbox-input',
            checkedClass: 'checked',
            disabledClass: '_disabled'
        }

        // Bindings
        this.$toggleOutsideParentItemClick = this.toggleOutsideParentItemClick.bind(this);
        this.$toggleSubtopicItemClick = this.toggleSubtopicItemClick.bind(this);

        this.init();
    }

    init() {
        const {
            inputClass,
            outsideParentItemClass,
            outsideParentInputClass,
            subtopicItemClass
        } = this.classList;
        const checkboxItems = [...document.querySelectorAll(`.${this.element}`)];

        if (checkboxItems) {
            checkboxItems.forEach(checkboxItem => {
                this.handleItemState(checkboxItem);
            });
        }

        this.outsideParentItem = document.querySelector(`.${outsideParentItemClass}`);
        this.childInputs = [...document.querySelectorAll(`.${inputClass}`)];
        this.subtopicItems = [...document.querySelectorAll(`.${subtopicItemClass}`)];

        if (this.outsideParentItem && this.childInputs) {
            this.outsideParentInput = this.outsideParentItem.querySelector(`.${outsideParentInputClass}`);
            this.outsideParentItem.addEventListener('click', this.$toggleOutsideParentItemClick);
        }

        if (this.subtopicItems) {
            this.subtopicItems.forEach(item => {
                item.addEventListener('click', this.$toggleSubtopicItemClick)
            });
        }
    }

    handleItemState(checkboxItem) {
        const { checkedClass, disabledClass, inputClass } = this.classList;
        const input = checkboxItem.querySelector(`.${inputClass}`);
        const isInputChecked = input.checked;
        const isInputDisabled = input.disabled;

        checkboxItem.classList.toggle(checkedClass, isInputChecked);

        if (!isInputDisabled) {
            checkboxItem.addEventListener('click', () => this.toggleItemClick(checkboxItem, input));
        } else {
            checkboxItem.classList.add(disabledClass);
        }
    }

    toggleItemClick(checkboxItem, input) {
        const { checkedClass} = this.classList;

        // Toggle the checked state of the input
        input.checked = !input.checked;

        // Update the class based on the new state
        checkboxItem.classList.toggle(checkedClass, input.checked);

        this.changeOutsideParentState();
        this.changeSubtopicsState(input);
        this.onItemClick();
    }

    changeOutsideParentState() {
        const { checkedClass} = this.classList;

        if (this.outsideParentItem && this.hasUncheckedChild()) {
            this.outsideParentInput.checked = false;
            this.outsideParentItem.classList.remove(checkedClass);
        }

        if (this.outsideParentItem && this.hasAllChildChecked()) {
            this.outsideParentInput.checked = true;
            this.outsideParentItem.classList.add(checkedClass);
        }
    }

    toggleOutsideParentItemClick(e) {
        e.stopImmediatePropagation();

        const { checkedClass, inputClass, subtopicInputClass } = this.classList;
        const childInputs = [...document.querySelectorAll(`.${inputClass}`)];
        const subtopicInputs = [...document.querySelectorAll(`.${subtopicInputClass}`)];
        const totalInputs = [...subtopicInputs, ...childInputs];

        // Toggle the checked state of the input
        this.outsideParentInput.checked = !this.outsideParentInput.checked;

        // Update the class based on the new state
        this.outsideParentItem.classList.toggle(checkedClass, this.outsideParentInput.checked);

        const isChecked = this.outsideParentInput.checked;

        // Reflect the parent's state in all child inputs
        totalInputs.forEach(childInput => {
            // Update the child input state
            childInput.checked = isChecked;

            // Update the class of the child element
            childInput.parentElement.classList.toggle(checkedClass, isChecked);
        });

        this.onOutsideParentClick();
    }

    hasAllChildChecked() {
        const { inputClass } = this.classList;
        const childInputs = [...document.querySelectorAll(`.${inputClass}`)];

        return childInputs.length > 0 && childInputs.every(child => child.checked);
    }

    hasAllChildUnchecked() {
        const { inputClass } = this.classList;
        const childInputs = [...document.querySelectorAll(`.${inputClass}`)];

        return childInputs.length > 0 && childInputs.every(child => !child.checked);
    }

    hasUncheckedChild() {
        const { inputClass } = this.classList;
        const childInputs = [...document.querySelectorAll(`.${inputClass}`)];

        return childInputs.length > 0 && childInputs.some(child => !child.checked);
    }

    hasSomeChildChecked() {
        const { inputClass } = this.classList;
        const childInputs = [...document.querySelectorAll(`.${inputClass}`)];

        return childInputs.length > 0 && childInputs.some(child => child.checked);
    }

    uncheckAllItems() {
        const { inputClass, checkedClass, subtopicInputClass } = this.classList;
        const childInputs = [...document.querySelectorAll(`.${inputClass}`)];
        const subtopicInputs = [...document.querySelectorAll(`.${subtopicInputClass}`)];
        const totalInputs = [...childInputs, ...subtopicInputs];

        // Uncheck child items
        if (totalInputs.length > 0) {
            totalInputs.forEach(child => {
                child.checked = false;
                child.parentElement.classList.remove(checkedClass);
            });
        }

        // Uncheck outside parent item
        this.outsideParentInput.checked = false;
        this.outsideParentItem.classList.remove(checkedClass);
    }

    onItemClick() {
        console.log('Checkbox item clicked');
    }

    onOutsideParentClick() {
        console.log('Outside parent item clicked');
    }

    toggleSubtopicItemClick(e) {
        e.stopImmediatePropagation();

        const { checkedClass, inputClass, subtopicInputClass } = this.classList;
        const targetItem = e.target;
        const categoryId = targetItem.dataset.categoryId;
        const targetInput = targetItem.querySelector(`.${subtopicInputClass}`);

        // Toggle the checked state of the input
        targetInput.checked = !targetInput.checked;

        // Update the class based on the new state
        targetItem.classList.toggle(checkedClass, targetInput.checked);

        const childInputs = [...document.querySelectorAll(`.${inputClass}[data-category-id="${categoryId}"]`)];
        const isChecked = targetInput.checked;

        if (childInputs) {
            childInputs.forEach(input => {
                input.parentElement.classList.toggle(checkedClass, isChecked);
                input.checked = isChecked;
            });
        }

        this.changeOutsideParentState();
        this.onOutsideParentClick();
    }

    changeSubtopicsState(input) {
        if (this.subtopicItems.length) {
            const {
                checkedClass,
                inputClass,
                subtopicItemClass,
                subtopicInputClass
            } = this.classList;
            const categoryId = input.dataset.categoryId;
            const childInputs = [...document.querySelectorAll(`.${inputClass}[data-category-id="${categoryId}"]`)];
            const subtopicItem = document.querySelector(`.${subtopicItemClass}[data-category-id="${categoryId}"]`);
            const subtopicInput = subtopicItem.querySelector(`.${subtopicInputClass}`);
            const allChecked = childInputs.length > 0 && childInputs.every(cb => cb.checked);

            if (subtopicItem) {
                subtopicItem.classList.toggle(checkedClass, allChecked);
                subtopicInput.checked = allChecked;
            }
        }
    }
}
